<template>
    <div>
        <header class="main-title">个人信息</header>

        <div class="com-model">
            <div class="content-item flex flex-between align-end">
                <div class="c-m-l flex">
                    <div class="avator-box">
                        <el-upload class="avatar-uploader" action="/wapi/base/upload/headImage" name="headImageFile"
                            :show-file-list="false" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="hrimg" :src="hrimg" class="avatar">
                            <img v-else class="avatar" src="../../assets/images/face.png" />
                        </el-upload>
                        <div class="change-btn">修改</div>
                    </div>
                    <div class="name-phone">
                        <div class="flex name">
                            <span>{{ hrnames }}</span>
                            <img src="../../assets/images/icon_edit.png" alt="edit" class="edit"
                                @click="openDialogName" />
                        </div>
                        <div class="flex">
                            <span>绑定手机：{{ hrinfo.phone }}</span>
                            <!-- <span class="s-d">换绑手机</span> -->
                        </div>
                    </div>
                </div>

                <div class="c-m-l flex wx-c-m">
                    <span>绑定微信：{{ hrinfo.isBindWechat ? hrinfo.phone : '未绑定' }}</span>
                    <span class="s-d" v-if="!hrinfo.isBindWechat" @click="showWxBindBox = !showWxBindBox">立刻绑定</span>

                    <div class="wx-box" v-if="!hrinfo.isBindWechat && showWxBindBox">
                        <div class="qr-tips">打开微信扫描验证码完成验证</div>
                        <div class="qr">
                        <wechartQR id="login_container" redirect-path="/index/home/person" />
                        </div>
                    </div>
                </div>
                <div class="c-m-l flex">
                    <span>登录密码：</span>
                    <span class="s-d" @click="modifyPassword">修改密码</span>
                </div>
            </div>
            <div class="split-line"></div>
            <div class="content-item flex flex-between">
                <div class="lef">
                    <div class="lef-t flex">
                        <span class="text-name">消息免打扰</span>
                        <span class="text-open" v-if="hrinfo.notDisturbStatus"><i class="el-icon-circle-check" />已开启</span>
                    </div>
                    <div class="lef-b flex">
                        <img src="../../assets/images/icon_msg_warn.png" alt="icon_warn" class="icon_warn" />
                        {{ `${hrinfo.notDisturbStatus ? '沟通免打扰开启中' : '开启沟通免打扰'}，免打扰时段19:00-次日8:00` }}
                    </div>
                </div>

                <el-switch v-model="hrinfo.notDisturbStatus" :on-value="1" :off-value="0" on-text="" off-text="" @change="handleStatusChange"></el-switch>
            </div>
            <div class="split-line"></div>
            <div class="content-item flex flex-between">
                <div class="text-name">所在公司</div>
                <div class="flex add-company pointer flex-center" @click="addCompany">
                    <i class="el-icon-view"></i>
                    加入新企业
                </div>
            </div>
            <div class="content-item flex flex-wrap m-t-23">
                <div class="company-item flex" :class="{ 'active': item.shortName === hrinfo.companyShortname }"
                    v-for="item in compyList" :key="item.id" @click="changeCompany(item)">
                    <img class="pic" :src="item.logo">
                    <div class="rig-box">
                        <div class="name flex">
                            <span>{{ item.shortName }}</span>
                            <span class="login-tag" v-if="item.shortName === hrinfo.companyShortname"><i
                                    class="el-icon-circle-check" />已登录</span>
                        </div>
                        <div class="post">{{ item.nickName }}</div>
                        <div :class="['role', roleBgClass(item.roleName)]">{{ item.roleName }}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="jobfair-box " >

            <div class="userbox">
                <div class="item flex">
                    <div class="label">个人头像</div>
                    <div class="value">
                        <el-upload
                        class="avatar-uploader"
                        action="/wapi/base/upload/headImage"
                        name="headImageFile"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                            <img v-if="hrimg" :src="hrimg" class="avatar">
                            <img v-else class="avatar" src="../../assets/images/face.png" />
                        </el-upload>
                    </div>
                </div>
                <div class="item flex">
                    <div class="label flex flex-between">
                        <span>姓</span>
                        <span>名</span>
                    </div>
                    <div class="input-box" style="width: auto">
                        <input v-model="hrnames" type="text" />
                    </div>
                    <div class="edit pointer" @click="modifyName">修改</div>
                </div>
                <div class="item flex">
                    <div class="label flex flex-between">
                        登录密码
                    </div>
                    <div class="edit pointer" @click="modifyPassword">修改密码</div>
                </div>
            </div>
        </div> -->
            <!-- 所在公司 -->
            <!-- <div class="company-box">
            <div class="in-title flex flex-between" style="max-width: 940px">
                所在公司
                <div class="flex add-company pointer" @click="addCompany">
                    <img src="../../assets/images/add-company-icon.png" />
                    加入新企业
                </div>
            </div>
            <div class="flex flex-wrap">
                <div class="item flex" v-for="item in compyList" :key="item.id">
                    <div class="comp-img flex flex-center">
                        <img :src="item.logo">
                    </div>
                    <div class="comp-info flex-grow">
                        <div class="tit">{{item.shortName}}</div>
                        <div class="comp-info-list ">
                            <p>{{item.nickName}}</p>
                        </div>
                         <div class="compwh-post-bar flex flex-between" >
                            <div class="compwh-post" :class="{
                                admin: item.role == 1
                            }">{{item.roleName}}</div>
                            <div class="compwh-loginout pointer" v-if="item.role != 1" @click="companyOut(item.companyId)">退出</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

            <el-dialog class="dialog-name" v-model="toggleName" title="修改昵称" size="large">
                <el-input v-model="hrnames2" type="text" placeholder="请输入昵称" />
                <span slot="footer" class="dialog-footer">
                    <el-button @click="toggleName = false">取 消</el-button>
                    <el-button type="primary" @click="changeName">保存</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import wechartQR from '../../components/wechartQR.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
const qs = require('qs')
export default {
    components: { wechartQR },
    data() {
        return {
            searchContent: '',
            isHrinfoShow: false,
            compyList: [],
            isnew: false,
            hrnames2: '',
            toggleName: false,
            code: null,
            showWxBindBox: false
        }
    },
    created() {
        this.getCompyList();
        const route = this.$route;
        this.code = route.query.code;
        if (this.code) {
            console.log('this.code', this.code)
            this.bindWx(this.code)
        }
    },
    computed: {
        ...mapState([
            'hrinfo', 'newname'
        ]),
        ...mapGetters([
            'hrimg', 'hrname'
        ]),
        hrnames: {
            get() {
                return this.hrname;
                // return this.$store.state.hrinfo.name;
            },
            set(value) {
                this.$store.commit('getnewName', value)
            }
        }
    },
    methods: {
        ...mapMutations(['hrinfoMo']),
        goback() {
            this.$router.back();
        },
        getCompyList() {
            let url = '/wapi/hr/listCompany';
            this.axios.get(url).then(res => {
                if (res.status) {
                    this.compyList = res.data;
                }
            })
        },
        addCompany() {
            this.$router.push({ path: "/register/join" })
        },
        modifyName() {
            let url = `/wapi/hr/modifyName?nickName=${this.newname}`;
            if (!this.newname) {
                this.$message({
                    type: 'info',
                    message: '请填写修改后的名字'
                })
                return
            }
            this.$confirm('确认将你的名字改为  ' + this.newname, '', {
                confirmButtonText: '是的',
                cancelButtonText: "取消"
            }).then(() => {
                this.axios.get(url).then(res => {
                    if (res.success) {
                        this.isnew = true;
                        this.$store.commit('hrChnageName', this.newname);
                        this.$message({
                            type: 'success',
                            message: '用户名修改成功'
                        })
                    }
                })
            })

        },
        beforeAvatarUpload() {
            return true
        },
        handleAvatarSuccess(res) {
            if (res.status * 1 == 200) {
                this.axios.get(`/wapi/hr/modifyHeadImage?headImage=${res.data}`).then(kres => {
                    this.$store.commit('hrChnageImg', res.data);
                    if (kres.status) {
                        this.$message({
                            type: 'success',
                            message: '上传成功'
                        })
                    }
                })
            }
        },
        companyOut(id) {
            this.axios.get(`/wapi/hr/exitCompany?optCompanyId=${id}`).then(res => {
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: '退出成功'
                    })
                    this.getCompyList();
                }
            })
        },
        modifyPassword() {
            this.$emit('pwd-modify')
        },
        modifyHrImg(event) {
            let formdata = new FormData();
            formdata.append('headImageFile', event.target.files[0]);
            this.axios.post('/wapi/base/upload/headImage', formdata).then(res => {
                if (res.status * 1 == 200) {
                    this.axios.get(`/wapi/hr/modifyHeadImage?headImage=${res.data}`).then(kres => {
                        this.$store.commit('hrChnageImg', res.data);
                        if (kres.status) {
                            this.$message({
                                type: 'success',
                                message: '上传成功'
                            })
                        }
                    })
                }
            })
        },
        openDialogName() {
            this.toggleName = true
            this.hrnames2 = this.hrnames
        },
        changeName() {
            this.toggleName = false
            let url = `/wapi/hr/modifyName?nickName=${this.hrnames2}`
            this.axios.get(url).then(res => {
                if (res.success) {
                    this.isnew = true;
                    this.$store.commit('hrChnageName', this.hrnames2)
                    this.$message({
                        type: 'success',
                        message: '用户名修改成功'
                    })
                }
            })
        },
        roleBgClass(val) {
            return val == '员工' ? 'bg-blue' : 'bg-yellow'
        },
        changeCompany({ companyId, name, shortName }) {
            if (this.hrinfo.companyShortname === shortName) return
            this.$confirm('切换后，企业相关的信息会切换为新的企业内容。', '确认需要切换企业吗？', {
                confirmButtonText: '确认切换',
                cancelButtonText: "取消"
            }).then(() => {
                let url = `/wapi/hr/swichCompany?companyId=${companyId}&companyName=${name}&companyShortName=${shortName}`;
                this.axios.get(url).then(res => {
                    if (res.success) {
                        window.location.reload();
                    }
                });
            })
        },
        bindWx(code) {
            const qdata = { code }
            this.axios.post('/wapi/pc/bind', qdata).then(res => {
                if (res.status === 200) {
                    this.$message({
                        type: 'success',
                        message: '微信绑定成功'
                    })
                    this.getInfo()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        getInfo() {
            this.axios.get('/wapi/hr/get').then(res => {
            this.hrinfoMo(res.data);
            // this.hrInfo = res.data;
            });
        },
        handleStatusChange(optType) {
            console.log('handleStatusChange--',optType)
            const loading = this.$loading()
            const data = {
                companyTel: this.hrinfo.companyTel,
                optType,
                timeList: ['19:00', '08:00']
            }
            this.axios.post('/wapi/hr/disturb/modify', data).then(res => {
                loading.close()
                const type = res.status === 200 ? 'success' : 'error'
                this.$message({
                    type,
                    message: res.msg
                })
                this.getInfo()
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
@import '../../assets/css/main';
@padding-left: 25px;

.main-title {
    line-height: 30px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-bottom: 15px;
    padding: 22px 24px;
    font-weight: bolder;
    font-size: 22px;
    color: #141414;
    text-align: justify;
    font-style: normal;
}

.com-model {
    background-color: #FFFFFF;
    padding: 30px 24px;
    border-radius: 10px;

    .content-item {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
    }

    .name-phone {
        margin-left: 16px;
    }

    .name {
        font-weight: bold;
        font-size: 22px;
        color: #141414;
        margin-bottom: 14px;
    }

    .edit {
        margin-left: 4px;
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    .avator-box {
        position: relative;
        width: 68px;
        height: 68px;
        border-radius: 50%;
        overflow: hidden;

        .avatar-uploader {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .change-btn {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 61px;
            height: 16px;
            background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%);
            z-index: 10;
            font-size: 12px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            line-height: 16px;
            pointer-events: none;
        }
    }

    .s-d {
        color: rgba(5, 124, 249, 1);
        margin-left: 12px;
        cursor: pointer;
    }

    .text-open {
        color: rgba(0, 180, 42, 1);
        font-size: 12px;
    }

    .icon_warn {
        width: 24px;
        height: 24px;
        margin-right: 10px;
    }

    .text-name {
        font-weight: bold;
        font-size: 22px;
        color: #141414;
    }

    .lef-t {
        margin-bottom: 20px;
    }

    .el-icon-circle-check {
        margin: 0 2px 0 8px;
    }

    .add-company {
        width: 126px;
        height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%);
        border-radius: 4px;

        font-size: 16px;
        color: rgba(255, 255, 255, 1);

        .el-icon-view {
            font-size: 16px;
            margin-right: 8px;
        }
    }
    .wx-c-m {
        position: relative;
        .wx-box {
            position: absolute;
            top: 100%;
            left: 20px;
            box-shadow: 0px 2px 8px 0px rgba(200,201,204,0.5);
            .qr-tips {
                font-size: 12px;
                color: #666666;
                line-height: 17px;
                margin-bottom: 6px;
                text-align: center;
            }
            .qr {
                width: 220px;
                height: 220px;
            }
        }
    }
}

/deep/ .dialog-name .el-dialog {
    width: 432px;
    height: 196px;
}

.split-line {
    width: 100%;
    height: 1px;
    border: 1px solid #EFEFEF;
    margin: 25px 0 35px 0;
}

.company-item {
    width: 500px;
    height: 134px;
    border-radius: 8px;
    border: 1px solid #E8F1F8;
    margin-bottom: 54px;
    padding: 16px;
    cursor: pointer;

    &.active {
        border: 2px solid rgba(5, 124, 249, 1);
    }

    &:nth-child(2n+1) {
        margin-right: 16px;
    }

    .pic {
        width: 102px;
        height: 102px;
        border-radius: 3px;
        margin-right: 16px;
    }

    .rig-box {
        .name {
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            line-height: 25px;
            margin-bottom: 9px;

            .el-icon-circle-check {
                margin: 0 2px 0 8px;
            }

            .login-tag {
                font-size: 12px;
                color: rgba(0, 180, 42, 1);
            }
        }

        .post {
            font-size: 16px;
            color: #333333;
            line-height: 22px;
            margin-bottom: 13px;
        }

        .role {
            display: inline-block;;
            height: 26px;
            line-height: 26px;
            background: #E8F3FF;
            border-radius: 4px;
            color: rgba(5, 124, 249, 1);
            padding: 2px 16px;
        }

        .bg-blue {
            color: rgba(5, 124, 249, 1);
            background-color: rgba(232, 243, 255, 1);
        }

        .bg-yellow {
            color: rgba(255, 125, 0, 1);
            background-color: rgba(255, 247, 232, 1);
        }
    }
}

.m-t-23 {
    margin-top: 23px;
}


.compwh-list {
    overflow: hidden;
    ;
    margin-bottom: 20px;
}

.compwh-info {
    width: 176px;
}

.compwh-post-bar {
    width: 100%;
    overflow: hidden;
}

.compwh-img img {
    width: 100%;
    height: 100%;
}

.userbox {
    padding: 44px 64px 40px;
    margin-left: 0 !important;

    .item {
        margin-bottom: 20px;
    }

    .label {
        width: 64px;
        color: #999999;
        font-size: 16px;
        margin-right: 30px;
    }

    .value {
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
    }

    .input-box {
        padding-left: 0;
        background: transparent;
        margin-right: 5px;

        input {
            padding-left: 5px;
            border-radius: 6px;
            border: 1px solid #E1E1E1 !important;

        }
    }

    .edit {
        color: #057CF9;
    }
}

.in-title {
    padding-left: @padding-left;
    line-height: 28px;
    color: #333333;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 32px;
}

.company-box {
    padding-left: @padding-left;

    .item {
        width: 460px;
        height: 164px;
        margin-bottom: 20px;
        margin-right: 48px;
        border-radius: 6px;
        border: 1px solid #E1E1E1;
        box-sizing: border-box;
        padding: 24px 78px 24px 33px;

        .comp-img {
            width: 116px;
            height: 116px;
            margin-right: 32px;

            img {
                max-width: 100%;
                max-height: 100%;
            }
        }

        .tit {
            font-size: 20px;
            color: #333333;
            font-weight: 400;
            margin-bottom: 18px;
        }

        .comp-info-list {
            font-size: 16px;
            color: #333333;
            margin-bottom: 18px;
        }

        .compwh-post {
            width: 80px;
            height: 32px;
            background: #057CF9;
            border-radius: 4px;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 32px;

            &.admin {
                background: #FE956B;
            }
        }

        .compwh-loginout {
            font-size: 16px;
            font-weight: 400;
            color: #057CF9;
            line-height: 22px;
        }
    }

    .add-company {
        font-size: 16px;
        color: #057CF9;

        img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// person.vue?44ca0a29